module.exports = __webpack_public_path__ + "assets/img/wg-2.07d28ad8.jpg";